import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { Funcoes } from "../funcoes";
import { Global } from "../global";
import { FichasModel } from "./fichas.model";
import { FichasService } from "./fichas.service";
import { TiposClientesService } from "../clientes/tipos-clientes.service";
import { PaisesService } from "../paises/paises.service";
import { BasicValidators } from "../shared/basic-validators";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { TransportesViagensService } from "../transportes-viagens/transportes-viagens.service";
import { UnidadesService } from "../unidades/unidades.service";
import { MercadoriasEmbalagensService } from "../mercadorias-embalagens/mercadorias-embalagens.service";
import { ObservacoesFichasService } from "../observacoes-fichas/observacoes-fichas.service";
import { ConclusoesFichasService } from "../conclusoes-fichas/conclusoes-fichas.service";
import { LoginService } from "../login/login.service";
import { UnidadesMedidasService } from "../unidades-medidas/unidades-medidas.service";
import { MercadoriasColoracaoService } from "../mercadorias-coloracao/mercadorias-coloracao.service";
import { ProtestosFichasService } from "../protestos-fichas/protestos-fichas.service";
import { ExportadoresService } from "../exportadores/exportadores.service";
import { TerminaisService } from "../terminais/terminais.service";
import { ArmadoresService } from "../armadores/armadores.service";
import { TranslateService } from '@ngx-translate/core';
import { ResponsaveisTecnicosService } from "../laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.service";

declare let $, swal: any;

@Component({
  selector: 'app-fichas-form',
  templateUrl: './fichas-form.component.html'
})
export class FichasFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  ficha: FichasModel = new FichasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  enviando = false;
  loadingData = false;

  temperaturasCount: number = 1;
  temperaturasTriplets: any[] = [];
  tempMin: number = null;
  tempMax: number = null;
  tempMedia: number = null;

  brixCount: number = 1;
  brixTriplets: any[] = [];
  brixMin: number = null;
  brixMax: number = null;
  brixMedia: number = null;

  tamanhoCalibreCount: number = 1;
  tamanhoCalibreTriplets: any[] = [];
  prevTermografosState: any[] = [];

  pressaoCount: number = 1;
  pressaoTriplets: any[] = [];
  pressaoMin: number = null;
  pressaoMax: number = null;
  pressaoMedia: number = null;

  listViagens = [];
  listPaises = [];
  listClientes = [];
  listImportador = [];
  listExportador = [];
  listArmador = [];
  listDespachante = [];
  listTerminal = [];
  listMercadorias = [];
  listVariedades = [];
  listUnidades = [];
  listEmbalagens = [];
  listDefeitos = [];
  panelCollapsed = [];
  defeitosSemIndiceCollapsed = false;
  listIndicesConclusao = [];
  listIndicesClassificacao = [];
  listIndicesClassificacaoCalculado = [];
  listObservacoes = [];
  listConclusoes = [];
  listProtestos = [];
  listOdores = [{ "texto": this.func.traduzir('front.odornormal'), "valor": "normal" }, { "texto": this.func.traduzir('front.odorestranho_ao_produto'), "valor": "estranho_ao_produto" }];
  listPressao = [{ "texto": this.func.traduzir('front.pressaominima'), "valor": "minima" }, { "texto": this.func.traduzir('front.pressaomaxima'), "valor": "maxima" }, { "texto": this.func.traduzir('front.pressaomedia'), "valor": "media" }];
  listFotos = [];
  listColoracoes = [];
  pesagens: any[] = [];

  conclusoesSelecionadas = [];
  observacoesSelecionadas = [];
  protestosSelecionados = [];
  indicesConclusaoSelecionados = [];
  modelIndicesConclusaoSelecionados = []; // guarda os valores selecionados nos indices de conclusao
  listResponsaveisTecnicos = [];
  listCores = [];
  responsaveisTecnicosSelecionados = [];

  listUnidadesMedidas = [];

  // Importacao de termografos
  importSourceType: string = 'fichas';
  numeroFichaImportar: string = '';
  fichaEncontradaParaImportacao: any = null;
  buscandoFichaImportar: boolean = false;
  mensagemErroImportacao: string = '';
  cacheTimestamp: number = new Date().getTime();

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private fichasService: FichasService,
    private tiposClientesService: TiposClientesService,
    private paisesService: PaisesService,
    private mercadoriasService: MercadoriasService,
    private transportesViagensService: TransportesViagensService,
    private unidadesService: UnidadesService,
    private mercadoriasEmbalagensService: MercadoriasEmbalagensService,
    private observacoesFichasService: ObservacoesFichasService,
    private conclusoesFichasService: ConclusoesFichasService,
    private protestosFichasService: ProtestosFichasService,
    private unidadesMedidasService: UnidadesMedidasService,
    private coloracoesService: MercadoriasColoracaoService,
    private exportadoresService: ExportadoresService,
    private terminaisService: TerminaisService,
    private armadoresService: ArmadoresService,
    private loginService: LoginService,
    private translateService: TranslateService,
    private responsaveisTecnicosService: ResponsaveisTecnicosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_ficha: [],
      id_cliente: ['', [
        Validators.required
      ]],
      id_importador: ['', [
        Validators.required
      ]],
      id_exportador: ['', [
        Validators.required
      ]],
      id_terminal: ['', [
        Validators.required
      ]],
      id_despachante: ['', [
        Validators.required
      ]],
      id_armador: ['', [
        Validators.required
      ]],
      id_pais_origem: ['', [
        Validators.required
      ]],
      id_viagem: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_unidade: ['', [
        Validators.required
      ]],
      referencia: [],
      fatura: [],
      container: ['', [
        BasicValidators.containerNumber
      ]],
      data_inspecao: ['', [
        Validators.required
      ]],
      conhecimento: [],
      id_mercadoria: [],
      marca: [],
      id_variedade: [],
      calibre: [],
      calibre_min: [],
      calibre_max: [],
      calibre_med: [],
      tamanho_calibre: [],
      odor: [],
      id_embalagem: [],
      lote: [],
      pressao_polpa: [],
      pressao_poupa_status: [],
      pressao_polpa_exibir: [],
      brix: [],
      brix_status: [],
      brix_exibir: [],
      em_conformidade: [],
      embalagem_avariada: [],
      rotulo_divergente: [],
      carga_avancada: [],
      sem_rotulo: [],
      carga_tombada_porta: [],
      carga_avancada_teto: [],
      estivagem: [],
      observacoes: [],
      conclusoes: [],
      protestos: [],
      setpoint: [],
      setpoint_off: [],
      airtemperature: [],
      airtemperature_off: [],
      ventilacao_bl: [],
      ventilacao_bl_fechado: [],
      temperatura_bl: [],
      temperaturas_polpa: [],
      temperatura_polpa_status: [],
      temperatura_polpa_exibir: [],
      temp_0: [],
      temp_1: [],
      temp_2: [],
      temp_3: [],
      temp_4: [],
      temp_5: [],
      temp_6: [],
      temp_7: [],
      temp_8: [],
      avaria_interna_container: [],
      avaria_externa_container: [],
      lacre_origem: [],
      lacre_fechamento: [],
      fotos: [],
      tipo_categoria_rotulo: [],
      data_validade: [],
      data_fabricacao: [],
      ventilacao_container: [],
      sem_ventilacao_container: [],
      ventilacao_container_automatico: [],
      ventilacao_container_unidade: [],
      ventilacao_bl_unidade: [],
      id_coloracao: [],
      protesto: [],
      is_dry: [],
      paletizacao: [],
      paletizacao_exibir: [],
      calibre_exibir: [],
      peso_liquido_vol: [],
      sem_pesagem: [],
      comentarios_exibir: [false],
      comentarios_pt: [],
      comentarios_en: [],
      comentarios_es: [],
      comentarios_cor: [null],
    });

    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];

    this.form.controls['comentarios_exibir'].valueChanges.subscribe(exibir => {
      this.atualizarValidadoresComentarios(exibir);
    });
  }

  atualizarValidadoresComentarios(exibir: boolean) {
    const campos = ['comentarios_pt', 'comentarios_en', 'comentarios_es'];
    campos.forEach(campo => {
      const control = this.form.controls[campo];
      if (control) {
        if (exibir) {
          control.setValidators([Validators.required, Validators.minLength(3)]);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity();
      }
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.indexOf('/upd') !== -1) {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.indexOf('/add') !== -1) {
      this.pageIsAdd = true;
    }

    // busca unidades
    this.unidadesService.get()
      .subscribe(json => {
        this.listUnidades = json.Payload;
      });

    // busca unidades de medidas
    this.unidadesMedidasService.get()
      .subscribe(json => {

        for (let d in json.Payload) {
          if (json.Payload[d].nome != 'CBM' && json.Payload[d].nome != 'CMH' && json.Payload[d].nome != 'PORCENTAGEM') {
            json.Payload.splice(d, 1);
          }
        }

        this.listUnidadesMedidas = json.Payload;
      });

    // busca coloracoes
    this.coloracoesService.get()
      .subscribe(json => {
        this.listColoracoes = json.Payload;
      });

    // busca mercadorias
    this.mercadoriasService.get()
      .subscribe(json => {
        this.listMercadorias = json.Payload;

        if (this.global.debug == true) {
          console.log(json.Payload);
        }
      });

    // busca paises
    this.paisesService.get()
      .subscribe(
        json => {
          this.listPaises = json.Payload;

          if (this.global.debug == true) {
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });



    // busca viagens de transportes
    this.transportesViagensService.get(["transporte", "local_descarga", "local_carregamento"])
      .subscribe(json => {
        console.log('API - Resposta viagens:', json);
        let listViagens = [];

        for (let i in json.Payload) {
          let transporte_nome = (json.Payload[i].transporte) ? json.Payload[i].transporte.nome : '-';
          let local_carregamento_sigla = (json.Payload[i].local_carregamento) ? json.Payload[i].local_carregamento.sigla : '-';
          let local_descarga_sigla = (json.Payload[i].local_descarga) ? json.Payload[i].local_descarga.sigla : '-';

          listViagens.push({
            "texto": transporte_nome + " - " + local_carregamento_sigla + " - " + local_descarga_sigla + " - ETD - " + this.func.formatDate('data', json.Payload[i].data_carregamento, this.loginService.getUserInfo(true)),
            "valor": json.Payload[i].id_viagem
          })
        }
        console.log('Angular - Lista de viagens processada:', listViagens);
        this.listViagens = listViagens;
      }, error => {
        console.error('API - Erro ao buscar viagens:', error);
      });


    // busca clientes por tipo (importador, despachante e cliente)
    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          for (let x in json.Payload) {
            switch (json.Payload[x].id_tipo) {
              case "1":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                this.listImportador = json.Payload[x].clientes;
                break;

              case "4":
                this.listDespachante = json.Payload[x].clientes;
                break;

              case "6":
                this.listClientes = this.func.mergeObjByProp(this.listClientes, json.Payload[x].clientes, 'id_cliente');
                break;
            }
          }

        },
        error => {
          this.func.showErro(error.json());
        });

    // busca exportadores da rota própria
    this.exportadoresService.get()
      .subscribe(
        json => {
          this.listExportador = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca terminais da rota própria
    this.terminaisService.get()
      .subscribe(
        json => {
          this.listTerminal = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    // busca armadores da rota própria
    this.armadoresService.get()
      .subscribe(
        json => {
          this.listArmador = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });


    // busca embalagens de mercadorias
    this.mercadoriasEmbalagensService.get()
      .subscribe(json => {
        this.listEmbalagens = json.Payload;
      });


    // busca observações
    this.observacoesFichasService.get()
      .subscribe(json => {
        this.listObservacoes = json.Payload;
        if (this.global.debug) {
          console.log('listObservacoes', this.listObservacoes);
        }
      });

    // busca protestos
    this.protestosFichasService.get()
      .subscribe(json => {
        this.listProtestos = json.Payload;
        if (this.global.debug) {
          console.log('listProtestos', this.listProtestos);
        }
      });

    // busca conclusões
    this.conclusoesFichasService.get()
      .subscribe(json => {
        this.listConclusoes = json.Payload;
      });

    this.responsaveisTecnicosService.get()
      .subscribe(json => {
        this.listResponsaveisTecnicos = json.Payload;

        const duplicateId = this.route.snapshot.queryParams['duplicate_id'];
        if (this.pageIsAdd && !duplicateId) {
          const selectedIds = [];
          const namesToSelect = ["HAILTON AZEVEDO PELAES"];
          if (this.listResponsaveisTecnicos) {
            this.listResponsaveisTecnicos.forEach(rt => {
              const rtName = rt.nome ? rt.nome.trim().toUpperCase() : '';
              if (namesToSelect.indexOf(rtName) !== -1) {
                selectedIds.push(rt.id);
              }
            });
          }
          this.responsaveisTecnicosSelecionados = selectedIds;
        }
      });


    this.route.queryParams.subscribe(queryParams => {
      let duplicate_id = queryParams['duplicate_id'];
      let prevista = queryParams['prevista'];

      if (this.pageIsAdd && (prevista == '1' || prevista == 1 || prevista == 'true' || this.router.url.indexOf('prevista=1') !== -1)) {
        this.ficha.id_status = 3;
      }

      this.checkStatusPrevista();

      if (this.pageIsAdd && duplicate_id) {
        this.title = prevista ? this.func.traduzir('front.duplicarPrevista') : this.func.traduzir('front.duplicarFicha');
        this.fichasService.getById(duplicate_id, ["responsaveis_tecnicos"])
          .subscribe(json => {
            if (json.Payload && json.Payload.length > 0) {
              let original = json.Payload[0];
              this.ficha = new FichasModel();

              // Dados para o patchValue
              let duplicateData: any = {
                id_cliente: original.id_cliente,
                id_importador: original.id_importador,
                id_exportador: original.id_exportador,
                id_terminal: original.id_terminal,
                id_despachante: original.id_despachante,
                id_armador: original.id_armador,
                id_pais_origem: original.id_pais_origem,
                id_viagem: original.id_viagem,
                id_unidade: original.id_unidade,
                referencia: original.referencia,
                fatura: original.fatura,
                container: original.container,
                conhecimento: original.conhecimento,
                data_inspecao: original.data_inspecao,
                id_status: prevista ? 3 : 1,

                // Logística e Temperatura Container
                setpoint: original.setpoint,
                setpoint_off: original.setpoint_off,
                airtemperature: original.airtemperature,
                airtemperature_off: original.airtemperature_off,
                ventilacao_bl: original.ventilacao_bl,
                ventilacao_bl_fechado: original.ventilacao_bl_fechado,
                temperatura_bl: original.temperatura_bl,
                ventilacao_container: original.ventilacao_container,
                sem_ventilacao_container: original.sem_ventilacao_container,
                ventilacao_container_automatico: original.ventilacao_container_automatico,
                ventilacao_container_unidade: original.ventilacao_container_unidade,
                ventilacao_bl_unidade: original.ventilacao_bl_unidade,
                avaria_interna_container: original.avaria_interna_container,
                avaria_externa_container: original.avaria_externa_container,
                lacre_origem: original.lacre_origem,
                lacre_fechamento: original.lacre_fechamento,
                carga_avancada_teto: original.carga_avancada_teto,
                protesto: original.protesto,
                is_dry: original.is_dry,
                paletizacao: original.paletizacao !== false,
                paletizacao_exibir: original.paletizacao_exibir !== false,
                calibre_exibir: original.calibre_exibir !== false,
                peso_liquido_vol: original.peso_liquido_vol !== false,
                sem_pesagem: original.sem_pesagem === true,
                pesagem: original.pesagem,
                estivagem: original.estivagem,
                calibre_min: original.calibre_min !== false,
                calibre_max: original.calibre_max !== false,
                calibre_med: original.calibre_med !== false,
                tamanho_calibre: original.tamanho_calibre
              };

              // Atualiza o objeto do modelo
              Object.assign(this.ficha, duplicateData);
              this.atualizarEstivagem();
              duplicateData.estivagem = this.ficha.estivagem;

              this.responsaveisTecnicosSelecionados = [];
              if (original.responsaveis_tecnicos) {
                for (let x in original.responsaveis_tecnicos) {
                  this.responsaveisTecnicosSelecionados.push(original.responsaveis_tecnicos[x].id);
                }
              }

              if (original.termografos) {
                let tgList = [];
                try {
                  tgList = typeof original.termografos === 'string' ? JSON.parse(original.termografos) : original.termografos;
                } catch (e) {
                  tgList = [];
                }
                if (Array.isArray(tgList) && tgList.length > 0) {
                  this.ficha.termografos = tgList.map(tg => {
                    tg.id = 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000);
                    tg.has_foto = false;
                    tg.has_foto_2 = false;
                    tg.has_foto_3 = false;
                    tg.has_foto_4 = false;
                    return tg;
                  });
                  this.ficha.termografos.forEach((tg, i) => {
                    this.registrarControlesTermografo(i, tg);
                  });
                } else {
                  this.ficha.termografos = [];
                }
              } else {
                this.ficha.termografos = [];
              }

              duplicateData.brix_status = original.brix_status !== false;
              if (original.brix) {
                let brixData = typeof original.brix === 'string' ? JSON.parse(original.brix) : original.brix;
                if (Array.isArray(brixData) && brixData.length > 0) {
                  this.brixCount = brixData.length;
                  brixData.forEach((b, i) => {
                    let control = new FormControl(b, []);
                    this.form.setControl('brix_' + i, control);
                    duplicateData['brix_' + i] = b;
                  });
                } else {
                  this.brixCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('brix_0', control);
                  duplicateData['brix_0'] = '';
                }
              } else {
                this.brixCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('brix_0', control);
                duplicateData['brix_0'] = '';
              }
              this.atualizarBrixTriplets();
              this.calcularMinMaxMediaBrix();

              duplicateData.temperatura_polpa_status = original.temperatura_polpa_status !== false;
              if (original.temperaturas_polpa) {
                let tempsData = typeof original.temperaturas_polpa === 'string' ? JSON.parse(original.temperaturas_polpa) : original.temperaturas_polpa;
                if (Array.isArray(tempsData) && tempsData.length > 0) {
                  let len = tempsData.length;
                  if (len > 6) len = 6;
                  this.temperaturasCount = len < 3 ? 3 : len;
                  for (let i = 0; i < this.temperaturasCount; i++) {
                    let val = tempsData[i] !== undefined ? tempsData[i] : '';
                    let control = new FormControl(val, []);
                    this.form.setControl('temp_' + i, control);
                    duplicateData['temp_' + i] = val;
                  }
                } else {
                  this.temperaturasCount = 3;
                  for (let i = 0; i < 3; i++) {
                    let control = new FormControl('', []);
                    this.form.setControl('temp_' + i, control);
                    duplicateData['temp_' + i] = '';
                  }
                }
              } else {
                this.temperaturasCount = 3;
                for (let i = 0; i < 3; i++) {
                  let control = new FormControl('', []);
                  this.form.setControl('temp_' + i, control);
                  duplicateData['temp_' + i] = '';
                }
              }
              this.atualizarTriplets();
              this.calcularMinMaxMedia();

              duplicateData.pressao_poupa_status = original.pressao_poupa_status !== false;
              if (original.pressao_polpa) {
                let pressaoData = typeof original.pressao_polpa === 'string' ? JSON.parse(original.pressao_polpa) : original.pressao_polpa;
                if (Array.isArray(pressaoData) && pressaoData.length > 0) {
                  this.pressaoCount = pressaoData.length;
                  pressaoData.forEach((p, i) => {
                    let control = new FormControl(p, []);
                    this.form.setControl('pressao_' + i, control);
                    duplicateData['pressao_' + i] = p;
                  });
                } else {
                  this.pressaoCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('pressao_0', control);
                  duplicateData['pressao_0'] = '';
                }
              } else {
                this.pressaoCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('pressao_0', control);
                duplicateData['pressao_0'] = '';
              }
              this.atualizarPressaoTriplets();
              this.calcularMinMaxMediaPressao();

              if (original.tamanho_calibre) {
                let tcData = original.tamanho_calibre.split(',').map(v => v.trim()).filter(v => v !== '');
                if (tcData.length > 0) {
                  this.tamanhoCalibreCount = tcData.length;
                  tcData.forEach((tc, i) => {
                    let control = new FormControl(tc, []);
                    this.form.setControl('tamanho_calibre_' + i, control);
                    duplicateData['tamanho_calibre_' + i] = tc;
                  });
                } else {
                  this.tamanhoCalibreCount = 1;
                  let control = new FormControl('', []);
                  this.form.setControl('tamanho_calibre_0', control);
                  duplicateData['tamanho_calibre_0'] = '';
                }
              } else {
                this.tamanhoCalibreCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('tamanho_calibre_0', control);
                duplicateData['tamanho_calibre_0'] = '';
              }
              this.atualizarTamanhoCalibreTriplets();
              this.carregarPesagem();

              // Atualiza o formulário reativo
              this.loadingData = true;
              this.form.patchValue(duplicateData);

              setTimeout(() => {
                let campos = ['em_conformidade', 'embalagem_avariada', 'rotulo_divergente', 'carga_avancada', 'sem_rotulo', 'carga_tombada_porta', 'carga_avancada_teto', 'is_dry', 'paletizacao', 'paletizacao_exibir', 'calibre_exibir', 'peso_liquido_vol', 'sem_pesagem', 'brix_status', 'brix_exibir', 'temperatura_polpa_status', 'temperatura_polpa_exibir', 'pressao_poupa_status', 'pressao_polpa_exibir', 'estivagem', 'calibre_min', 'calibre_max', 'calibre_med', 'comentarios_exibir'];
                campos.forEach(campo => {
                  let valor = !!duplicateData[campo];
                  this.form.controls[campo].setValue(valor);
                  if (valor) {
                    $('#' + campo).bootstrapToggle('on');
                  } else {
                    $('#' + campo).bootstrapToggle('off');
                  }
                });
                this.loadingData = false;
              }, 500);
            }
          });
      } else if (this.pageIsAdd) {
        this.conclusoesSelecionadas = ["320909735852156928"];
        this.brixCount = 1;
        let control = new FormControl('', []);
        this.form.setControl('brix_0', control);
        this.ficha['brix_0'] = '';
        this.ficha.brix_status = true;
        this.ficha.brix_exibir = true;
        this.atualizarBrixTriplets();
        this.calcularMinMaxMediaBrix();

        this.temperaturasCount = 3;
        for (let i = 0; i < 3; i++) {
          let controlTemp = new FormControl('', []);
          this.form.setControl('temp_' + i, controlTemp);
          this.ficha['temp_' + i] = '';
        }
        this.ficha.temperatura_polpa_status = true;
        this.ficha.temperatura_polpa_exibir = true;
        this.atualizarTriplets();
        this.calcularMinMaxMedia();

        this.pressaoCount = 1;
        let controlPressao = new FormControl('', []);
        this.form.setControl('pressao_0', controlPressao);
        this.ficha['pressao_0'] = '';
        this.ficha.pressao_poupa_status = true;
        this.ficha.pressao_polpa_exibir = true;
        this.atualizarPressaoTriplets();
        this.calcularMinMaxMediaPressao();

        this.ficha.estivagem = true;
        this.atualizarEstivagem();

        this.tamanhoCalibreCount = 1;
        let controlCalibre = new FormControl('', []);
        this.form.setControl('tamanho_calibre_0', controlCalibre);
        this.ficha['tamanho_calibre_0'] = '';
        this.ficha.calibre_min = true;
        this.ficha.calibre_max = true;
        this.ficha.calibre_med = true;
        this.ficha.paletizacao_exibir = true;
        this.ficha.calibre_exibir = true;
        this.atualizarTamanhoCalibreTriplets();
        this.carregarPesagem();
      }
    });

    this.route.params.subscribe(params => {
      let id = params['id_ficha'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarFicha');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarFicha') : this.func.traduzir('front.cadastrarNovaFicha');
      }

      if (!id) {
        return;
      }

      this.fichasService.getById(id, ["observacoes", "conclusoes", "protestos", "defeitos", "fotos", "responsaveis_tecnicos"])
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarFicha') + ': ' + json.Payload[0].numero;
            } else {
              this.title = this.func.traduzir('front.visualizarFicha') + ': ' + json.Payload[0].numero;
            }

            this.loadingData = true;
            this.ficha = Object.assign(new FichasModel(), json.Payload[0]);

            if (this.ficha.paletizacao_exibir === undefined || this.ficha.paletizacao_exibir === null) {
              this.ficha.paletizacao_exibir = true;
            }
            if (this.ficha.calibre_exibir === undefined || this.ficha.calibre_exibir === null) {
              this.ficha.calibre_exibir = true;
            }

            if (this.ficha.brix) {
              let brixData = typeof this.ficha.brix === 'string' ? JSON.parse(this.ficha.brix) : this.ficha.brix;
              if (Array.isArray(brixData) && brixData.length > 0) {
                this.brixCount = brixData.length;
                brixData.forEach((b, i) => {
                  let control = new FormControl(b, []);
                  this.form.setControl('brix_' + i, control);
                  this.ficha['brix_' + i] = b;
                });
              } else {
                this.brixCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('brix_0', control);
                this.ficha['brix_0'] = '';
              }
            } else {
              this.brixCount = 1;
              let control = new FormControl('', []);
              this.form.setControl('brix_0', control);
              this.ficha['brix_0'] = '';
            }
            this.atualizarBrixTriplets();
            this.calcularMinMaxMediaBrix();

            if (this.ficha.temperaturas_polpa) {
              let tempsData = typeof this.ficha.temperaturas_polpa === 'string' ? JSON.parse(this.ficha.temperaturas_polpa) : this.ficha.temperaturas_polpa;
              if (Array.isArray(tempsData) && tempsData.length > 0) {
                let len = tempsData.length;
                if (len > 6) len = 6;
                this.temperaturasCount = len < 3 ? 3 : len;
                for (let i = 0; i < this.temperaturasCount; i++) {
                  let val = tempsData[i] !== undefined ? tempsData[i] : '';
                  let control = new FormControl(val, []);
                  this.form.setControl('temp_' + i, control);
                  this.ficha['temp_' + i] = val;
                }
              } else {
                this.temperaturasCount = 3;
                for (let i = 0; i < 3; i++) {
                  let control = new FormControl('', []);
                  this.form.setControl('temp_' + i, control);
                  this.ficha['temp_' + i] = '';
                }
              }
            } else {
              this.temperaturasCount = 3;
              for (let i = 0; i < 3; i++) {
                let control = new FormControl('', []);
                this.form.setControl('temp_' + i, control);
                this.ficha['temp_' + i] = '';
              }
            }
            this.atualizarTriplets();
            this.calcularMinMaxMedia();

            if (this.ficha.pressao_polpa) {
              let pressaoData = typeof this.ficha.pressao_polpa === 'string' ? JSON.parse(this.ficha.pressao_polpa) : this.ficha.pressao_polpa;
              if (Array.isArray(pressaoData) && pressaoData.length > 0) {
                this.pressaoCount = pressaoData.length;
                pressaoData.forEach((p, i) => {
                  let control = new FormControl(p, []);
                  this.form.setControl('pressao_' + i, control);
                  this.ficha['pressao_' + i] = p;
                });
              } else {
                this.pressaoCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('pressao_0', control);
                this.ficha['pressao_0'] = '';
              }
            } else {
              this.pressaoCount = 1;
              let control = new FormControl('', []);
              this.form.setControl('pressao_0', control);
              this.ficha['pressao_0'] = '';
            }
            this.atualizarPressaoTriplets();
            this.calcularMinMaxMediaPressao();

            if (this.ficha.termografos) {
              let tgList = [];
              try {
                tgList = typeof this.ficha.termografos === 'string' ? JSON.parse(this.ficha.termografos) : this.ficha.termografos;
              } catch (e) {
                tgList = [];
              }
              if (Array.isArray(tgList) && tgList.length > 0) {
                this.ficha.termografos = tgList.map(tg => {
                  if (!tg.id) {
                    tg.id = 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000);
                  }
                  return tg;
                });
                this.ficha.termografos.forEach((tg, i) => {
                  this.registrarControlesTermografo(i, tg);
                });
              } else {
                this.ficha.termografos = [];
              }
            } else {
              this.ficha.termografos = [];
            }

            this.checkStatusPrevista();
            this.atualizarEstivagem();

            if (this.ficha.tamanho_calibre) {
              let tcData = this.ficha.tamanho_calibre.split(',').map(v => v.trim()).filter(v => v !== '');
              if (tcData.length > 0) {
                this.tamanhoCalibreCount = tcData.length;
                tcData.forEach((tc, i) => {
                  let control = new FormControl(tc, []);
                  this.form.setControl('tamanho_calibre_' + i, control);
                  this.ficha['tamanho_calibre_' + i] = tc;
                });
              } else {
                this.tamanhoCalibreCount = 1;
                let control = new FormControl('', []);
                this.form.setControl('tamanho_calibre_0', control);
                this.ficha['tamanho_calibre_0'] = '';
              }
            } else {
              this.tamanhoCalibreCount = 1;
              let control = new FormControl('', []);
              this.form.setControl('tamanho_calibre_0', control);
              this.ficha['tamanho_calibre_0'] = '';
            }
            this.atualizarTamanhoCalibreTriplets();
            this.carregarPesagem();
            setTimeout(() => {
              let fichaData: any = Object.assign({}, this.ficha);
              delete fichaData.fotos;
              this.form.patchValue(fichaData);
              // Força a atualização dos campos booleanos específicos para garantir o visual
              let campos = ['em_conformidade', 'embalagem_avariada', 'rotulo_divergente', 'carga_avancada', 'sem_rotulo', 'carga_tombada_porta', 'carga_avancada_teto', 'is_dry', 'paletizacao', 'paletizacao_exibir', 'calibre_exibir', 'peso_liquido_vol', 'sem_pesagem', 'brix_status', 'brix_exibir', 'temperatura_polpa_status', 'temperatura_polpa_exibir', 'pressao_poupa_status', 'pressao_polpa_exibir', 'estivagem', 'calibre_min', 'calibre_max', 'calibre_med', 'comentarios_exibir'];

              campos.forEach(campo => {
                let valor = !!this.ficha[campo];
                this.form.controls[campo].setValue(valor);
                // Força o bootstrapToggle via jQuery caso o Angular não tenha conseguido
                if (valor) {
                  $('#' + campo).bootstrapToggle('on');
                } else {
                  $('#' + campo).bootstrapToggle('off');
                }
              });

              this.loadingData = false;
            }, 500);
            this.listFotos = json.Payload[0].fotos;

            let defeitosFicha = json.Payload[0].defeitos;

            for (let x in this.ficha.observacoes) {
              this.observacoesSelecionadas.push(this.ficha.observacoes[x].id_observacao);
            }

            for (let x in this.ficha.conclusoes) {
              this.conclusoesSelecionadas.push(this.ficha.conclusoes[x].id_conclusao);
            }

            for (let x in this.ficha.protestos) {
              this.protestosSelecionados.push(this.ficha.protestos[x].id_protesto);
            }

            this.responsaveisTecnicosSelecionados = [];
            if (json.Payload[0].responsaveis_tecnicos) {
              for (let x in json.Payload[0].responsaveis_tecnicos) {
                this.responsaveisTecnicosSelecionados.push(json.Payload[0].responsaveis_tecnicos[x].id);
              }
            }

            //console.log('observacoesSelecionadas', this.observacoesSelecionadas);
            //console.log('conclusoesSelecionadas', this.conclusoesSelecionadas);

            //this.indicesConclusaoSelecionados = this.ficha.indices_conclusao;

            // busca variedades, dedeitos, indices de conclusão e indices de classicação relacionados a mercadoria

            // exibe a tab de fotos
            if (this.route.snapshot.queryParams["abafotos"] == '1') {
              $('a[href="#abafotos"]').tab('show');
            }

            if (this.ficha.id_mercadoria) {
              this.mercadoriasService.getById(this.ficha.id_mercadoria, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"])
                .subscribe(json => {

                  //console.log('Variedades e Defeitos e Indices', json.Payload);

                  this.listVariedades = json.Payload[0].variedades;

                  this.listIndicesConclusao = json.Payload[0].indices_conclusao;
                  //console.log('Indices Conclusao', this.listIndicesConclusao);

                  this.listIndicesClassificacao = json.Payload[0].indices_classificacao;
                  console.log('Indices Classificacao', this.listIndicesClassificacao);

                  for (let j in this.listIndicesConclusao) {
                    //console.log('indice', this.listIndicesConclusao[j]);

                    let control: FormControl = new FormControl('indiceConclusao' + j, [Validators.required, BasicValidators.notNull]);
                    this.form.setControl('indiceConclusao' + j, control); // instead of this.obj[key]

                    let comModelIndice = false;

                    for (let k in this.listIndicesConclusao[j].itens) {
                      //console.log('itens', this.listIndicesConclusao[j].itens[k]);

                      for (let q in this.ficha.indices_conclusao) {
                        //console.log(this.listIndicesConclusao[j].nome_pt+' = '+this.ficha.indices_conclusao[q].nome_pt)

                        if (this.listIndicesConclusao[j].nome_pt == this.ficha.indices_conclusao[q].nome_pt) {
                          //console.log(this.listIndicesConclusao[j].itens[k].nome_pt+' == '+this.ficha.indices_conclusao[q].valor.nome_pt)

                          if (this.listIndicesConclusao[j].itens[k].nome_pt == this.ficha.indices_conclusao[q].valor.nome_pt) {
                            //console.log('valor selecionado', k);
                            this.modelIndicesConclusaoSelecionados.push(k);
                            //console.log('modelIndicesConclusaoSelecionados', this.modelIndicesConclusaoSelecionados);
                            comModelIndice = true;

                            this.indicesConclusaoSelecionados.push({
                              "nome_pt": this.listIndicesConclusao[j].nome_pt,
                              "nome_en": this.listIndicesConclusao[j].nome_en,
                              "nome_es": this.listIndicesConclusao[j].nome_es,
                              "valor": {
                                "nome_pt": this.listIndicesConclusao[j].itens[k].nome_pt,
                                "nome_en": this.listIndicesConclusao[j].itens[k].nome_en,
                                "nome_es": this.listIndicesConclusao[j].itens[k].nome_es
                              }
                            });
                          }

                        }
                      }

                    }

                    if (!comModelIndice) {
                      this.modelIndicesConclusaoSelecionados.push(null);
                      this.indicesConclusaoSelecionados.push({
                        "nome_pt": this.listIndicesConclusao[j].nome_pt,
                        "nome_en": this.listIndicesConclusao[j].nome_en,
                        "nome_es": this.listIndicesConclusao[j].nome_es,
                        "valor": {
                          "nome_pt": null,
                          "nome_en": null,
                          "nome_es": null
                        }
                      });
                      //console.log('modelIndicesConclusaoSelecionados', this.modelIndicesConclusaoSelecionados);
                    }

                  }

                  // zera defeitos
                  this.listDefeitos = [];
                  // adiciona defeito por defeito
                  for (let x in json.Payload[0].defeitos) {

                    let control: FormControl = new FormControl('defeito' + x, []);
                    this.form.setControl('defeito' + x, control);
                    let controlAtivo: FormControl = new FormControl('defeitoAtivo' + x, []);
                    this.form.setControl('defeitoAtivo' + x, controlAtivo);

                    let valor = 0.00;
                    let ativo = true;

                    for (let z in defeitosFicha) {
                      if (defeitosFicha[z].id_defeito == json.Payload[0].defeitos[x].id) {
                        valor = defeitosFicha[z].valor;
                        ativo = (defeitosFicha[z].ativo == 1 || defeitosFicha[z].ativo == true);
                      }
                    }

                    this.listDefeitos.push({
                      "id_defeito": json.Payload[0].defeitos[x].id,
                      "nome_pt": json.Payload[0].defeitos[x].nome_pt,
                      "valor": valor,
                      "ativo": ativo,
                      "is_indice_acumulado": json.Payload[0].defeitos[x].is_indice_acumulado,
                      "indices_acumulados": json.Payload[0].defeitos[x].indices_acumulados,
                      "ordem": json.Payload[0].defeitos[x].ordem
                    });
                  }

                  this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);

                });
            }

            console.log("this.ficha.setpoint_off" + " = " + this.ficha.setpoint_off);
            console.log("this.ficha.setpoint" + " = " + this.ficha.setpoint);

            // valida is_dry
            if (
              (!this.ficha.setpoint_off && (this.ficha.setpoint == "" || this.ficha.setpoint == null)) &&
              (!this.ficha.airtemperature_off && (this.ficha.airtemperature == "" || this.ficha.airtemperature == null))
            ) {
              this.ficha.is_dry = true;
            }

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  // evento quando o container é alterado
  changeContainer(e) {
    this.ficha.container = e.toUpperCase();
  }

  // evento quando o is_dry é alterado
  changeIsDry(i) {
    if (i) {
      this.ficha.setpoint = null;
      this.ficha.airtemperature = null;
      this.ficha.ventilacao_container = "";
      this.ficha.ventilacao_bl = "";
      this.ficha.temperatura_bl = null;
      this.ficha.setpoint_off = false;
      this.ficha.airtemperature_off = false;
      this.ficha.sem_ventilacao_container = false;
      this.ficha.ventilacao_container_automatico = false;
      this.ficha.ventilacao_bl_fechado = false;
    }
  }

  atualizarEstivagem() {
    let hasCargaAvancada = (this.ficha.carga_avancada === true || (this.ficha.carga_avancada as any) === 1 || (this.ficha.carga_avancada as any) === '1');
    let hasCargaAvancadaTeto = (this.ficha.carga_avancada_teto === true || (this.ficha.carga_avancada_teto as any) === 1 || (this.ficha.carga_avancada_teto as any) === '1');
    let hasCargaTombadaPorta = (this.ficha.carga_tombada_porta === true || (this.ficha.carga_tombada_porta as any) === 1 || (this.ficha.carga_tombada_porta as any) === '1');

    let isConforme = (!hasCargaAvancada && !hasCargaAvancadaTeto && !hasCargaTombadaPorta);

    this.ficha.estivagem = isConforme;
    if (this.form.controls['estivagem']) {
      this.form.controls['estivagem'].setValue(isConforme);
    }
  }

  atualizarEmConformidadeEmbalagem() {
    if (this.loadingData) {
      return;
    }
    let hasRotuloDivergente = (this.ficha.rotulo_divergente === true || (this.ficha.rotulo_divergente as any) === 1 || (this.ficha.rotulo_divergente as any) === '1');
    let hasSemRotulo = (this.ficha.sem_rotulo === true || (this.ficha.sem_rotulo as any) === 1 || (this.ficha.sem_rotulo as any) === '1');
    let hasEmbalagemAvariada = (this.ficha.embalagem_avariada === true || (this.ficha.embalagem_avariada as any) === 1 || (this.ficha.embalagem_avariada as any) === '1');

    let isConforme = (!hasRotuloDivergente && !hasSemRotulo && !hasEmbalagemAvariada);

    this.ficha.em_conformidade = isConforme;
    if (this.form && this.form.controls['em_conformidade']) {
      this.form.controls['em_conformidade'].setValue(isConforme);
    }
  }

  // evento chamado quando a mercadoria é alterada
  changeMercadoria(e) {

    // busca variedades, dedeitos e indices de conclusão relacionados a mercadoria
    this.mercadoriasService.getById(e, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"])
      .subscribe(json => {
        //console.log('Variedades e Defeitos e Indices', json.Payload);

        this.listVariedades = json.Payload[0].variedades;
        this.ficha.id_variedade = null;

        this.listIndicesConclusao = json.Payload[0].indices_conclusao;
        this.listIndicesClassificacao = json.Payload[0].indices_classificacao;

        //console.log('Indices', this.listIndicesConclusao);

        this.indicesConclusaoSelecionados = [];
        this.modelIndicesConclusaoSelecionados = [];

        for (let j in this.listIndicesConclusao) {
          //console.log('indice', this.listIndicesConclusao[j]);

          let indice = {
            "nome_pt": this.listIndicesConclusao[j].nome_pt,
            "nome_en": this.listIndicesConclusao[j].nome_en,
            "nome_es": this.listIndicesConclusao[j].nome_es,
            "valor": {
              "nome_pt": null,
              "nome_en": null,
              "nome_es": null
            }
          };

          this.indicesConclusaoSelecionados.push(indice);
          this.modelIndicesConclusaoSelecionados.push(null);

          let control: FormControl = new FormControl('indiceConclusao' + j, [Validators.required]);
          this.form.setControl('indiceConclusao' + j, control); // instead of this.obj[key]

          for (let k in this.listIndicesConclusao[j].itens) {
            //console.log('itens', this.listIndicesConclusao[j].itens[k]);
          }

        }

        let defeitosFicha = json.Payload[0].defeitos;

        // zera defeitos
        this.listDefeitos = [];

        // adiciona defeito por defeito
        for (let x in json.Payload[0].defeitos) {

          let control: FormControl = new FormControl('defeito' + x, []);
          this.form.setControl('defeito' + x, control);
          let controlAtivo: FormControl = new FormControl('defeitoAtivo' + x, []);
          this.form.setControl('defeitoAtivo' + x, controlAtivo);

          let valor = 0.00;
          let ativo = true;

          for (let z in defeitosFicha) {
            if (defeitosFicha[z].id_defeito == json.Payload[0].defeitos[x].id) {
              valor = defeitosFicha[z].valor;
              ativo = (defeitosFicha[z].ativo == 1 || defeitosFicha[z].ativo == true);
            }
          }

          this.listDefeitos.push({
            "id_defeito": json.Payload[0].defeitos[x].id,
            "nome_pt": json.Payload[0].defeitos[x].nome_pt,
            "valor": valor,
            "ativo": ativo,
            "is_indice_acumulado": json.Payload[0].defeitos[x].is_indice_acumulado,
            "indices_acumulados": json.Payload[0].defeitos[x].indices_acumulados,
            "ordem": json.Payload[0].defeitos[x].ordem
          });
        }

        this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);

      }, error => {
        this.listVariedades = [];
        this.ficha.id_variedade = null;
        this.listDefeitos = [];
      });

  }

  changeNaoConformidade(e) {
    if (this.loadingData) {
      return;
    }
    if (e) {
      this.ficha.rotulo_divergente = false;
      this.ficha.sem_rotulo = false;
      this.ficha.embalagem_avariada = false;
    }
  }

  changeTermografoCaracteristicas(i) {
    const tg = this.ficha.termografos[i];
    const prev = this.prevTermografosState[i] || { inicializado: true, encontrado: true, sem_dados_restritos: true };

    const inicializado = tg.inicializado !== false;
    const encontrado = tg.encontrado !== false;
    const semDadosRestritos = tg.sem_dados_restritos !== false;

    const inicializadoChangedToFalse = (!inicializado && prev.inicializado);
    const encontradoChangedToFalse = (!encontrado && prev.encontrado);
    const semDadosRestritosChangedToFalse = (!semDadosRestritos && prev.sem_dados_restritos);

    if (inicializadoChangedToFalse) {
      tg.encontrado = true;
      if (this.form.controls['termografo_' + i + '_encontrado']) {
        this.form.controls['termografo_' + i + '_encontrado'].setValue(true);
      }
      tg.sem_dados_restritos = true;
      if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
        this.form.controls['termografo_' + i + '_sem_dados_restritos'].setValue(true);
      }
    } else if (encontradoChangedToFalse) {
      tg.inicializado = true;
      if (this.form.controls['termografo_' + i + '_inicializado']) {
        this.form.controls['termografo_' + i + '_inicializado'].setValue(true);
      }
      tg.sem_dados_restritos = true;
      if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
        this.form.controls['termografo_' + i + '_sem_dados_restritos'].setValue(true);
      }
    } else if (semDadosRestritosChangedToFalse) {
      tg.inicializado = true;
      if (this.form.controls['termografo_' + i + '_inicializado']) {
        this.form.controls['termografo_' + i + '_inicializado'].setValue(true);
      }
      tg.encontrado = true;
      if (this.form.controls['termografo_' + i + '_encontrado']) {
        this.form.controls['termografo_' + i + '_encontrado'].setValue(true);
      }
    }

    this.prevTermografosState[i] = {
      inicializado: tg.inicializado !== false,
      encontrado: tg.encontrado !== false,
      sem_dados_restritos: tg.sem_dados_restritos !== false
    };

    if (!tg.inicializado || tg.encontrado === false || tg.sem_dados_restritos === false) {
      if (!tg.inicializado) {
        if (this.form.controls['termografo_' + i + '_temperatura_minima']) {
          this.form.controls['termografo_' + i + '_temperatura_minima'].setValue('');
        }
        if (this.form.controls['termografo_' + i + '_temperatura_media']) {
          this.form.controls['termografo_' + i + '_temperatura_media'].setValue('');
        }
        if (this.form.controls['termografo_' + i + '_temperatura_maxima']) {
          this.form.controls['termografo_' + i + '_temperatura_maxima'].setValue('');
        }
      }
      if (this.form.controls['termografo_' + i + '_status']) {
        this.form.controls['termografo_' + i + '_status'].setValue(true);
      }
      if (this.form.controls['termografo_' + i + '_excesso_transit_time']) {
        this.form.controls['termografo_' + i + '_excesso_transit_time'].setValue(false);
        tg.excesso_transit_time = false;
      }
      if (this.form.controls['termografo_' + i + '_fora_alcance']) {
        this.form.controls['termografo_' + i + '_fora_alcance'].setValue(false);
        tg.fora_alcance = false;
      }
      if (this.form.controls['termografo_' + i + '_com_defeito']) {
        this.form.controls['termografo_' + i + '_com_defeito'].setValue(false);
        tg.com_defeito = false;
      }
      if (this.form.controls['termografo_' + i + '_fora_tolerancia']) {
        this.form.controls['termografo_' + i + '_fora_tolerancia'].setValue(false);
        tg.fora_tolerancia = false;
      }
    }
  }

  registrarControlesTermografo(i: number, tg: any) {
    if (tg && tg.id) {
      this.form.setControl('termografo_foto_' + tg.id + '_1', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_2', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_3', new FormControl('', []));
      this.form.setControl('termografo_foto_' + tg.id + '_4', new FormControl('', []));
    }
    this.form.setControl('termografo_' + i + '_inicializado', new FormControl(tg.inicializado !== false, []));
    this.form.setControl('termografo_' + i + '_encontrado', new FormControl(tg.encontrado !== false, []));
    this.form.setControl('termografo_' + i + '_sem_dados_restritos', new FormControl(tg.sem_dados_restritos !== false, []));
    this.form.setControl('termografo_' + i + '_numero', new FormControl(tg.numero || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_minima', new FormControl(tg.temperatura_minima || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_maxima', new FormControl(tg.temperatura_maxima || '', []));
    this.form.setControl('termografo_' + i + '_temperatura_media', new FormControl(tg.temperatura_media || '', []));
    if (tg.excesso_transit_time || tg.com_defeito || tg.fora_alcance || tg.fora_tolerancia) {
      tg.status = false;
    }
    this.form.setControl('termografo_' + i + '_status', new FormControl(tg.status !== false, []));
    this.form.setControl('termografo_' + i + '_excesso_transit_time', new FormControl(tg.excesso_transit_time || false, []));
    this.form.setControl('termografo_' + i + '_fora_alcance', new FormControl(tg.fora_alcance || false, []));
    this.form.setControl('termografo_' + i + '_com_defeito', new FormControl(tg.com_defeito || false, []));
    this.form.setControl('termografo_' + i + '_fora_tolerancia', new FormControl(tg.fora_tolerancia || false, []));
    this.prevTermografosState[i] = {
      inicializado: tg.inicializado !== false,
      encontrado: tg.encontrado !== false,
      sem_dados_restritos: tg.sem_dados_restritos !== false
    };
  }

  verificarStatusTermografo(i: number) {
    const tg = this.ficha.termografos[i];
    if (tg && (tg.excesso_transit_time || tg.com_defeito || tg.fora_alcance || tg.fora_tolerancia)) {
      tg.status = false;
      if (this.form.controls['termografo_' + i + '_status']) {
        this.form.controls['termografo_' + i + '_status'].setValue(false);
      }
    }
  }

  removerControlesTermografo(i: number) {
    let tg = this.ficha.termografos[i];
    if (tg && tg.id) {
      this.form.removeControl('termografo_foto_' + tg.id + '_1');
      this.form.removeControl('termografo_foto_' + tg.id + '_2');
      this.form.removeControl('termografo_foto_' + tg.id + '_3');
      this.form.removeControl('termografo_foto_' + tg.id + '_4');
    }
    this.form.removeControl('termografo_' + i + '_inicializado');
    this.form.removeControl('termografo_' + i + '_encontrado');
    this.form.removeControl('termografo_' + i + '_sem_dados_restritos');
    this.form.removeControl('termografo_' + i + '_numero');
    this.form.removeControl('termografo_' + i + '_temperatura_minima');
    this.form.removeControl('termografo_' + i + '_temperatura_maxima');
    this.form.removeControl('termografo_' + i + '_temperatura_media');
    this.form.removeControl('termografo_' + i + '_status');
    this.form.removeControl('termografo_' + i + '_excesso_transit_time');
    this.form.removeControl('termografo_' + i + '_fora_alcance');
    this.form.removeControl('termografo_' + i + '_com_defeito');
    this.form.removeControl('termografo_' + i + '_fora_tolerancia');
  }

  syncTermografosFromForm() {
    if (this.ficha.termografos) {
      this.ficha.termografos.forEach((tg, i) => {
        if (this.form.controls['termografo_' + i + '_inicializado']) {
          tg.inicializado = this.form.controls['termografo_' + i + '_inicializado'].value;
        }
        if (this.form.controls['termografo_' + i + '_encontrado']) {
          tg.encontrado = this.form.controls['termografo_' + i + '_encontrado'].value;
        }
        if (this.form.controls['termografo_' + i + '_sem_dados_restritos']) {
          tg.sem_dados_restritos = this.form.controls['termografo_' + i + '_sem_dados_restritos'].value;
        }
        if (this.form.controls['termografo_' + i + '_numero']) {
          tg.numero = this.form.controls['termografo_' + i + '_numero'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_minima']) {
          tg.temperatura_minima = this.form.controls['termografo_' + i + '_temperatura_minima'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_maxima']) {
          tg.temperatura_maxima = this.form.controls['termografo_' + i + '_temperatura_maxima'].value;
        }
        if (this.form.controls['termografo_' + i + '_temperatura_media']) {
          tg.temperatura_media = this.form.controls['termografo_' + i + '_temperatura_media'].value;
        }
        if (this.form.controls['termografo_' + i + '_status']) {
          tg.status = this.form.controls['termografo_' + i + '_status'].value;
        }
        if (this.form.controls['termografo_' + i + '_excesso_transit_time']) {
          tg.excesso_transit_time = this.form.controls['termografo_' + i + '_excesso_transit_time'].value;
        }
        if (this.form.controls['termografo_' + i + '_fora_alcance']) {
          tg.fora_alcance = this.form.controls['termografo_' + i + '_fora_alcance'].value;
        }
        if (this.form.controls['termografo_' + i + '_com_defeito']) {
          tg.com_defeito = this.form.controls['termografo_' + i + '_com_defeito'].value;
        }
        if (this.form.controls['termografo_' + i + '_fora_tolerancia']) {
          tg.fora_tolerancia = this.form.controls['termografo_' + i + '_fora_tolerancia'].value;
        }
      });
    }
  }

  addTermografo() {
    if (!this.ficha.termografos) {
      this.ficha.termografos = [];
    }
    const nextIdx = this.ficha.termografos.length;
    const newTg = {
      id: 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000),
      inicializado: true,
      encontrado: true,
      sem_dados_restritos: true,
      numero: '',
      temperatura_minima: '',
      temperatura_maxima: '',
      temperatura_media: '',
      status: true,
      excesso_transit_time: false,
      fora_alcance: false,
      com_defeito: false,
      fora_tolerancia: false,
      has_foto: false
    };
    this.ficha.termografos.push(newTg);
    this.registrarControlesTermografo(nextIdx, newTg);

    setTimeout(() => {
      let el = document.getElementById('termografo_' + nextIdx + '_numero');
      if (el) {
        el.focus();
      }
    }, 50);
  }

  removeTermografo(idx: number) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: "Deseja realmente remover este termógrafo?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.syncTermografosFromForm();
        
        // Remove all controls from form
        self.ficha.termografos.forEach((_, i) => {
          self.removerControlesTermografo(i);
        });

        self.ficha.termografos.splice(idx, 1);

        // Re-register controls
        self.ficha.termografos.forEach((tg, i) => {
          self.registrarControlesTermografo(i, tg);
        });
      });
  }

  abrirModalImportarTermografo(tipo: string = 'fichas') {
    this.importSourceType = tipo;
    this.numeroFichaImportar = '';
    this.fichaEncontradaParaImportacao = null;
    this.buscandoFichaImportar = false;
    this.mensagemErroImportacao = '';
    $('#modalImportarTermografo').modal('show');
  }

  buscarFichaPorNumero() {
    if (!this.numeroFichaImportar) {
      return;
    }
    this.buscandoFichaImportar = true;
    this.mensagemErroImportacao = '';
    this.fichaEncontradaParaImportacao = null;

    this.fichasService.buscarTermografosPorNumero(this.importSourceType, this.numeroFichaImportar)
      .subscribe(
        json => {
          this.buscandoFichaImportar = false;
          if (json.Success && json.Payload && json.Payload.length > 0) {
            const f = json.Payload[0];
            if (typeof f.termografos === 'string') {
              f.termografos = JSON.parse(f.termografos);
            }
            if (f.termografos && f.termografos.length > 0) {
              this.fichaEncontradaParaImportacao = f;
            } else {
              this.mensagemErroImportacao = this.func.traduzir('front.nenhumTermografoCadastrado');
            }
          } else {
            this.mensagemErroImportacao = this.func.traduzir('front.nenhumLaudoEncontradoNumero');
          }
        },
        err => {
          this.buscandoFichaImportar = false;
          this.mensagemErroImportacao = this.func.traduzir('front.erroImportarTermografo');
        }
      );
  }

  confirmarImportacaoTermografo(tgSelecionado: any) {
    if (!this.fichaEncontradaParaImportacao || !tgSelecionado) {
      return;
    }
    let sourceId = '';
    if (this.importSourceType === 'fichas') {
      sourceId = this.fichaEncontradaParaImportacao.id_ficha;
    } else if (this.importSourceType === 'laudos-cd') {
      sourceId = this.fichaEncontradaParaImportacao.id_laudo_cd;
    } else if (this.importSourceType === 'laudos-tecnicos') {
      sourceId = this.fichaEncontradaParaImportacao.id_laudo_tecnico;
    }

    const targetTgId = 'tg_' + new Date().getTime() + '_' + Math.floor(Math.random() * 10000);
    this.fichasService.importarTermografo(this.ficha.id_ficha, sourceId, tgSelecionado.id, targetTgId, this.importSourceType)
      .subscribe(
        json => {
          if (json.Success) {
            this.syncTermografosFromForm();

            // Remove todos os controles anteriores do form
            this.ficha.termografos.forEach((_, i) => {
              this.removerControlesTermografo(i);
            });

            // Cria o novo objeto do termografo importado
            const novoTg = {
              id: targetTgId,
              inicializado: tgSelecionado.inicializado || false,
              encontrado: tgSelecionado.encontrado !== false,
              sem_dados_restritos: tgSelecionado.sem_dados_restritos !== false,
              numero: tgSelecionado.numero || '',
              temperatura_minima: tgSelecionado.temperatura_minima || '',
              temperatura_maxima: tgSelecionado.temperatura_maxima || '',
              temperatura_media: tgSelecionado.temperatura_media || '',
              status: tgSelecionado.status !== false,
              excesso_transit_time: tgSelecionado.excesso_transit_time || false,
              fora_alcance: tgSelecionado.fora_alcance || false,
              com_defeito: tgSelecionado.com_defeito || false,
              fora_tolerancia: tgSelecionado.fora_tolerancia || false,
              has_foto: tgSelecionado.has_foto || false,
              has_foto_2: tgSelecionado.has_foto_2 || false,
              has_foto_3: tgSelecionado.has_foto_3 || false,
              has_foto_4: tgSelecionado.has_foto_4 || false
            };

            this.ficha.termografos.push(novoTg);

            // Re-registra todos os controles no form
            this.ficha.termografos.forEach((tg, i) => {
              this.registrarControlesTermografo(i, tg);
            });

            $('#modalImportarTermografo').modal('hide');
            swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.termografoImportadoSucesso'), "success");
          } else {
            swal(this.func.traduzir('front.erro'), this.func.traduzir('front.erroImportarTermografo'), "error");
          }
        },
        err => {
          swal(this.func.traduzir('front.erro'), this.func.traduzir('front.erroImportarTermografo'), "error");
        }
      );
  }

  uploadTermografoComplete(tg, resp, index: number) {
    let jsonResp;
    try {
      jsonResp = typeof resp === 'string' ? JSON.parse(resp) : resp;
    } catch (e) {}

    if (jsonResp && jsonResp.Success) {
      if (index === 1) tg.has_foto = true;
      if (index === 2) tg.has_foto_2 = true;
      if (index === 3) tg.has_foto_3 = true;
      if (index === 4) tg.has_foto_4 = true;
      this.cacheTimestamp = new Date().getTime();
      this.syncTermografosFromForm();
    }
  }

  apagaFotoTermografo(tg, index: number) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFotoFicha'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        self.fichasService.apagaFotoTermografo(self.ficha.id_ficha, tg.id, index)
          .subscribe(json => {
            if (json.Success) {
              if (index === 1) tg.has_foto = false;
              if (index === 2) tg.has_foto_2 = false;
              if (index === 3) tg.has_foto_3 = false;
              if (index === 4) tg.has_foto_4 = false;
              self.cacheTimestamp = new Date().getTime();
              self.syncTermografosFromForm();
            }
          });
      });
  }

  girarFotoTermografo(tg, index: number = 1) {
    let self = this;
    this.fichasService.girarFotoTermografo(this.ficha.id_ficha, tg.id, index)
      .subscribe(json => {
        this.cacheTimestamp = new Date().getTime();
        this.func.alerta(this.func.traduzir('front.sucesso'), this.func.traduzir('front.fotoRotacionadaComSucesso'), 'sucesso');
      }, erro => {
        this.func.showErro(erro.json());
      });
  }

  changeSetPoint(e) {
    if (e) {
      this.ficha.setpoint = '';
    }
  }

  changeAirTemperature(e) {
    if (e) {
      this.ficha.airtemperature = '';
    }
  }

  changeVentilacaoBLFechado(e) {
    if (e) {
      this.ficha.ventilacao_bl = '';
    }
  }

  changeVentilacaoContainer(e) {
    if (e) {
      this.ficha.ventilacao_container = '';
    }
  }

  changeVentilacaoContainerAutomatico(e) {
    if (e) {
      this.ficha.ventilacao_container = '';
      this.ficha.sem_ventilacao_container = false;
    }
  }

  addObservacao() {
    this.observacoesSelecionadas.push(null);
  }

  removeObservacao(indice) {
    this.observacoesSelecionadas.splice(indice, 1);
  }

  addConclusao() {
    this.conclusoesSelecionadas.push(null);
  }

  removeConclusao(indice) {
    this.conclusoesSelecionadas.splice(indice, 1);
  }

  addProtesto() {
    this.protestosSelecionados.push(null);
  }

  removeProtesto(indice) {
    this.protestosSelecionados.splice(indice, 1);
  }

  formatOptionText(texto: string, maxLen: number = 110): string {
    if (!texto) return '';
    const clean = texto.trim().replace(/\s+/g, ' ');
    return clean.length > maxLen ? clean.substring(0, maxLen) + '...' : clean;
  }

  formatProtestoOption(texto: string, maxLen: number = 110): string {
    return this.formatOptionText(texto, maxLen);
  }

  getProtestoTexto(id: any): string {
    if (!id || !this.listProtestos) return '';
    const item = this.listProtestos.find(p => p.id_protesto == id);
    return item ? (item.protesto_pt || item.protesto_en || item.protesto_es || '') : '';
  }

  getObservacaoTexto(id: any): string {
    if (!id || !this.listObservacoes) return '';
    const item = this.listObservacoes.find(o => o.id_observacao == id);
    return item ? (item.observacao_pt || item.observacao_en || item.observacao_es || '') : '';
  }

  getConclusaoTexto(id: any): string {
    if (!id || !this.listConclusoes) return '';
    const item = this.listConclusoes.find(c => c.id_conclusao == id);
    return item ? (item.conclusao_pt || item.conclusao_en || item.conclusao_es || '') : '';
  }

  updateIndiceConclusao(i, event) {
    /*console.log('indice', i);
    console.log('evento', event);
    console.log('value', event.target.value);

    console.log('indice', this.listIndicesConclusao[i]);
    console.log('valores', this.listIndicesConclusao[i].itens[event.target.value]);*/

    if (event.target.value == null || event.target.value == 'null') {
      this.indicesConclusaoSelecionados[i] = {
        "nome_pt": this.listIndicesConclusao[i].nome_pt,
        "nome_en": this.listIndicesConclusao[i].nome_en,
        "nome_es": this.listIndicesConclusao[i].nome_es,
        "valor": {
          "nome_pt": null,
          "nome_en": null,
          "nome_es": null
        }
      };
    } else {
      this.indicesConclusaoSelecionados[i] = {
        "nome_pt": this.listIndicesConclusao[i].nome_pt,
        "nome_en": this.listIndicesConclusao[i].nome_en,
        "nome_es": this.listIndicesConclusao[i].nome_es,
        "valor": {
          "nome_pt": this.listIndicesConclusao[i].itens[event.target.value].nome_pt,
          "nome_en": this.listIndicesConclusao[i].itens[event.target.value].nome_en,
          "nome_es": this.listIndicesConclusao[i].itens[event.target.value].nome_es
        }
      };
    }


    //console.log('indicesSelecionados', this.indicesConclusaoSelecionados);
  }

  checkStatusPrevista() {
    if (this.ficha && this.form && this.form.get('data_inspecao')) {
      if (this.ficha.id_status == 3) {
        this.form.get('data_inspecao').clearValidators();
        this.form.get('data_inspecao').updateValueAndValidity();
      } else {
        this.form.get('data_inspecao').setValidators([Validators.required]);
        this.form.get('data_inspecao').updateValueAndValidity();
      }
    }
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;

    // valida indices de classificação
    for (let i in this.listIndicesClassificacaoCalculado) {
      //console.log(this.listIndicesClassificacaoCalculado[i]);

      if (this.listIndicesClassificacaoCalculado[i] == this.func.traduzir('front.nenhumIndiceEncontrado')) {
        this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.umOuMaisIndicesClassificacaoErrado'), 'erro');
        this.enviando = false;
        return false;
      }
    }


    this.ficha.indices_conclusao = this.indicesConclusaoSelecionados;

    // valida as observacoes selecionadas
    let observacoesOK = true;
    this.observacoesSelecionadas = this.func.uniqueArray(this.observacoesSelecionadas);
    for (let x in this.observacoesSelecionadas) {
      if (this.observacoesSelecionadas[x] == 'null' || this.observacoesSelecionadas[x] == null) {
        observacoesOK = false;
      }
    }

    if (!observacoesOK) {
      this.func.alerta(this.func.traduzir('front.observacoesInvalidas'), this.func.traduzir('front.observacoesIncorretasOuFaltando'), 'erro');
      this.enviando = false;
      return false;
    }

    // valida as conclusoes selecionadas
    let conclusoesOK = true;
    this.conclusoesSelecionadas = this.func.uniqueArray(this.conclusoesSelecionadas);
    for (let x in this.conclusoesSelecionadas) {
      if (this.conclusoesSelecionadas[x] == 'null' || this.conclusoesSelecionadas[x] == null) {
        conclusoesOK = false;
      }
    }

    if (!conclusoesOK) {
      this.func.alerta(this.func.traduzir('front.conclusoesInvalidas'), this.func.traduzir('front.conclusoesIncorretasOuFaltando'), 'erro');
      this.enviando = false;
      return false;
    }

    // valida as protestos selecionadas
    let protestosOK = true;
    if (this.ficha.protesto) {
      if (!this.protestosSelecionados || this.protestosSelecionados.length === 0) {
        protestosOK = false;
      } else {
        this.protestosSelecionados = this.func.uniqueArray(this.protestosSelecionados);
        for (let x in this.protestosSelecionados) {
          if (this.protestosSelecionados[x] == 'null' || this.protestosSelecionados[x] == null || this.protestosSelecionados[x] === '') {
            protestosOK = false;
          }
        }
      }
    } else {
      this.protestosSelecionados = [];
    }

    if (!protestosOK) {
      this.func.alerta(this.func.traduzir('front.protestosInvalidos'), this.func.traduzir('front.protestosIncorretosOuFaltando'), 'erro');
      this.enviando = false;
      return false;
    }

    // valida os responsaveis tecnicos selecionados
    let rtsOK = true;
    this.responsaveisTecnicosSelecionados = this.func.uniqueArray(this.responsaveisTecnicosSelecionados);
    for (let x in this.responsaveisTecnicosSelecionados) {
      if (this.responsaveisTecnicosSelecionados[x] == 'null' || this.responsaveisTecnicosSelecionados[x] == null) {
        rtsOK = false;
      }
    }

    if (!rtsOK) {
      this.func.alerta(this.func.traduzir('front.erro'), 'Um ou mais responsáveis técnicos estão incorretos ou em branco', 'erro');
      this.enviando = false;
      return false;
    }

    this.syncTermografosFromForm();

    this.ficha.conclusoes = this.conclusoesSelecionadas;
    this.ficha.observacoes = this.observacoesSelecionadas;
    this.ficha.protestos = this.protestosSelecionados;
    this.ficha.responsaveis_tecnicos = this.responsaveisTecnicosSelecionados;

    this.ficha['defeitos'] = this.listDefeitos;

    //console.log(this.ficha);

    let result,
      values = Object.assign({}, this.ficha); //this.form.value;

    Object.keys(values).forEach(key => {
      if (key.startsWith('termografo_')) {
        delete values[key];
      }
    });

    let brixList = [];
    for (let i = 0; i < this.brixCount; i++) {
      let val = this.form.controls['brix_' + i] ? this.form.controls['brix_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        brixList.push(val);
      }
    }
    values.brix = brixList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('brix_') && key !== 'brix_status' && key !== 'brix_exibir') {
        delete values[key];
      }
    });

    let tempPolpaList = [];
    for (let i = 0; i < this.temperaturasCount; i++) {
      let val = this.form.controls['temp_' + i] ? this.form.controls['temp_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        tempPolpaList.push(val);
      }
    }
    values.temperaturas_polpa = tempPolpaList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('temp_') && key !== 'temperatura_polpa_status' && key !== 'temperatura_polpa_exibir') {
        delete values[key];
      }
    });

    let pressaoList = [];
    for (let i = 0; i < this.pressaoCount; i++) {
      let val = this.form.controls['pressao_' + i] ? this.form.controls['pressao_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        pressaoList.push(val);
      }
    }
    values.pressao_polpa = pressaoList;
    Object.keys(values).forEach(key => {
      if (key.startsWith('pressao_') && key !== 'pressao_polpa' && key !== 'pressao_poupa_status' && key !== 'pressao_polpa_exibir') {
        delete values[key];
      }
    });

    let tamanhoCalibreList = [];
    for (let i = 0; i < this.tamanhoCalibreCount; i++) {
      let val = this.form.controls['tamanho_calibre_' + i] ? this.form.controls['tamanho_calibre_' + i].value : null;
      if (val !== null && val !== undefined && val !== '') {
        if (typeof val === 'string') {
          val = val.replace(/,/g, '.');
        }
        tamanhoCalibreList.push(val);
      }
    }
    values.tamanho_calibre = tamanhoCalibreList.join(',');
    Object.keys(values).forEach(key => {
      if (key.startsWith('tamanho_calibre_')) {
        delete values[key];
      }
    });

    this.syncPesagensFromForm();
    let compiledPesagens = [];
    this.pesagens.forEach((pesagem) => {
      let vols = [];
      pesagem.volumes.forEach((vol) => {
        if (vol !== null && vol !== undefined && vol !== '') {
          vols.push(vol);
        }
      });
      compiledPesagens.push({
        volumes: vols,
        tara: pesagem.tara,
        peso_liquido: pesagem.peso_liquido,
        diferenca_final: pesagem.diferenca_final,
        exibir: pesagem.exibir
      });
    });
    values.pesagem = compiledPesagens;
    
    Object.keys(values).forEach(key => {
      if (key.startsWith('pesagem_') || key === 'peso_liquido') {
        delete values[key];
      }
    });

    if (values.id_ficha) {
      this.fichasService.editar(values, values.id_ficha)
        .subscribe(data => {
          if (this.ficha.id_status == 3) {
            this.router.navigate(['/painel', 'fichas', 'previstas']);
          } else {
            this.router.navigate(['/painel', 'fichas']);
          }
        },
          error => {
            this.enviando = false;
            this.func.showErro(error.json());
          });
    } else {
      this.fichasService.adicionar(values)
        .subscribe(data => {
          if (this.ficha.id_status == 3) {
            this.router.navigate(['/painel', 'fichas', 'previstas']);
          } else {
            this.router.navigate(['/painel', 'fichas', data.Payload, 'upd'], { queryParams: { abafotos: '1' } });
          }
        },
          error => {
            this.enviando = false;
            this.func.showErro(error.json());
          });
    }



  }

  loadVenobox() {
    $('.venobox').venobox();
  }

  ordenouFotos(e) {
    //console.log(e);
    //console.log(this.listFotos);

    for (let i in this.listFotos) {
      //console.log('foto', this.listFotos[i]);
      this.listFotos[i].ordem = parseInt(i) + 1;
    }

    this.fichasService.ordenaFotos(this.listFotos, this.ficha.id_ficha)
      .subscribe(json => {
        console.log(json);
      })
  }

  apagaFoto(indice) {

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarFotoFicha'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {

        self.fichasService.apagaFoto(self.ficha.id_ficha, self.listFotos[indice].id_foto)
          .subscribe(json => {
            self.listFotos.splice(indice, 1);
          }, erro => {
            self.fichasService.trataErro(erro.json());
          });

      });

  }

  girarFoto(indice) {
    let self = this;
    let foto = this.listFotos[indice];
    this.fichasService.girarFoto(this.ficha.id_ficha, foto.id_foto)
      .subscribe(json => {
        foto.timestamp = new Date().getTime();
        setTimeout(() => {
          self.loadVenobox();
        }, 100);
        this.func.alerta(this.func.traduzir('front.sucesso'), this.func.traduzir('front.fotoRotacionadaComSucesso'), 'sucesso');
      }, erro => {
        this.fichasService.trataErro(erro.json());
      });
  }

  uploadFotosComplete(resp) {
    try {
      let json = JSON.parse(resp).Payload;

      for (let i in json) {
        //console.log('json', json[i])
        this.listFotos.push(json[i]);
      }

    }
    catch (e) { }
  }

  baixarFotosZip() {
    this.fichasService.zipFotos(this.ficha.id_ficha)
      .subscribe(json => {
        window.open(this.fichasService.dominio + json.Payload[0], '_blank');
      });
  }

  changeDefeitos(i, e) {
    if (this.listDefeitos[i] && parseFloat(this.listDefeitos[i].valor) > 100) {
      this.listDefeitos[i].valor = 100;
      if (this.form && this.form.controls && this.form.controls['defeito' + i]) {
        this.form.controls['defeito' + i].setValue(100, { emitEvent: false });
      }
    }
    this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);

    // Se for índice acumulado, atualiza o estado ativo de todos os sub-defeitos
    if (this.listDefeitos[i].is_indice_acumulado) {
      let subDefeitos = this.getSubDefeitos(this.listDefeitos[i]);
      for (let sub of subDefeitos) {
        let subIdx = this.getDefeitoIndex(sub.id_defeito);
        if (subIdx !== -1) {
          this.listDefeitos[subIdx].ativo = e;
          if (this.form && this.form.controls && this.form.controls['defeitoAtivo' + subIdx]) {
            this.form.controls['defeitoAtivo' + subIdx].setValue(e);
          }
          if (e === false) {
            this.listDefeitos[subIdx].valor = 0;
            if (this.form && this.form.controls && this.form.controls['defeito' + subIdx]) {
              this.form.controls['defeito' + subIdx].setValue(0);
            }
          }
        }
      }
      this.recalculaIndiceAcumulado(this.listDefeitos[i].id_defeito);
    }

    // verificar se ele faz parte de algum indice acumulado
    for (let c in this.listDefeitos) {
      if (this.listDefeitos[c].is_indice_acumulado) {
        for (let z in this.listDefeitos[c].indices_acumulados) {
          if (this.listDefeitos[c].indices_acumulados[z].id_defeito_indice == this.listDefeitos[i].id_defeito) {
            this.recalculaIndiceAcumulado(this.listDefeitos[c].id_defeito);
          }
        }
      }
    }

    this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
  }

  recalculaIndiceAcumulado(id_defeito) {
    let valor = 0;

    for (let i in this.listDefeitos) {
      if (this.listDefeitos[i].id_defeito == id_defeito) {
        for (let z in this.listDefeitos[i].indices_acumulados) {

          // busca os ids dos indices calculados para pegar o valor atual
          for (let q in this.listDefeitos) {
            if (this.listDefeitos[i].indices_acumulados[z].id_defeito_indice == this.listDefeitos[q].id_defeito) {
              valor = valor + parseFloat(this.listDefeitos[q].valor);
            }
          }
        }
      }
    }

    if (valor > 100) {
      valor = 100;
    }

    for (let q in this.listDefeitos) {
      if (id_defeito == this.listDefeitos[q].id_defeito) {
        this.listDefeitos[q].valor = valor;
        this.listIndicesClassificacaoCalculado = this.func.calculaIndicesClassificacao(this.listIndicesClassificacao, this.listDefeitos);
      }
    }
  }

  formatValor(valor: any): string {
    if (valor === undefined || valor === null) {
      return '0,00';
    }
    let parsed = parseFloat(valor);
    if (isNaN(parsed)) {
      return '0,00';
    }
    return parsed.toFixed(2).replace('.', ',');
  }

  getDefeitoIndex(id_defeito: any) {
    return this.listDefeitos.findIndex(d => d.id_defeito == id_defeito);
  }

  getSubDefeitos(defeitoAcumulado: any) {
    let list = [];
    if (defeitoAcumulado && defeitoAcumulado.indices_acumulados) {
      for (let sub of defeitoAcumulado.indices_acumulados) {
        let found = this.listDefeitos.find(d => d.id_defeito == sub.id_defeito_indice);
        if (found) {
          list.push(found);
        }
      }
    }
    return list.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  defeitoPertenceAAlgumAcumulado(defeitoId: any): boolean {
    for (let d of this.listDefeitos) {
      if (d.is_indice_acumulado && d.indices_acumulados) {
        for (let sub of d.indices_acumulados) {
          if (sub.id_defeito_indice == defeitoId) {
            return true;
          }
        }
      }
    }
    return false;
  }

  temDefeitosSemIndiceAcumulado(): boolean {
    if (!this.listDefeitos) return false;
    return this.listDefeitos.some(d => !d.is_indice_acumulado && !this.defeitoPertenceAAlgumAcumulado(d.id_defeito));
  }

  atualizarTriplets() {
    let triplets = [];
    for (let i = 0; i < this.temperaturasCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.temperaturasCount) trip.push(i + 1);
      if (i + 2 < this.temperaturasCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.temperaturasTriplets = triplets;
  }

  addTemperatura() {
    if (this.temperaturasCount < 6) {
      let nextIdx = this.temperaturasCount;
      let control = new FormControl('', []);
      this.form.setControl('temp_' + nextIdx, control);
      this.ficha['temp_' + nextIdx] = '';
      this.temperaturasCount++;
      this.atualizarTriplets();
      this.calcularMinMaxMedia();
      
      setTimeout(() => {
        let el = document.getElementById('temp_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeTemperatura(idx: number) {
    if (this.temperaturasCount > 3) {
      for (let i = idx; i < this.temperaturasCount - 1; i++) {
        let nextVal = this.form.controls['temp_' + (i + 1)].value;
        this.form.controls['temp_' + i].setValue(nextVal);
        this.ficha['temp_' + i] = nextVal;
      }
      let lastIdx = this.temperaturasCount - 1;
      this.form.removeControl('temp_' + lastIdx);
      delete this.ficha['temp_' + lastIdx];
      
      this.temperaturasCount--;
      this.atualizarTriplets();
      this.calcularMinMaxMedia();
    }
  }

  calcularMinMaxMedia() {
    let validValues = [];
    for (let i = 0; i < this.temperaturasCount; i++) {
      let control = this.form.controls['temp_' + i];
      if (control) {
        let val = control.value;
        if (val !== null && val !== undefined && val !== '') {
          let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
          if (!isNaN(valFloat) && isFinite(valFloat)) {
            validValues.push(valFloat);
          }
        }
      }
    }

    if (validValues.length > 0) {
      this.tempMin = Math.min(...validValues);
      this.tempMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.tempMedia = sum / validValues.length;
    } else {
      this.tempMin = null;
      this.tempMax = null;
      this.tempMedia = null;
    }
  }

  validateForm(form) {
    for (let i in form['controls']) {
      this.form['controls'][i].markAsTouched()
    }
  }

  changeProtesto(e) {
    if (!e) {
      this.protestosSelecionados = [];
    } else {
      if (this.protestosSelecionados.length === 0) {
        this.protestosSelecionados.push(null);
      }
    }
  }

  atualizarBrixTriplets() {
    let triplets = [];
    for (let i = 0; i < this.brixCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.brixCount) trip.push(i + 1);
      if (i + 2 < this.brixCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.brixTriplets = triplets;
  }

  addBrix() {
    if (this.brixCount < 20) {
      let nextIdx = this.brixCount;
      let control = new FormControl('', []);
      this.form.setControl('brix_' + nextIdx, control);
      this.ficha['brix_' + nextIdx] = '';
      this.brixCount++;
      this.atualizarBrixTriplets();
      this.calcularMinMaxMediaBrix();
      
      setTimeout(() => {
        let el = document.getElementById('brix_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeBrix(idx: number) {
    if (this.brixCount > 1) {
      for (let i = idx; i < this.brixCount - 1; i++) {
        let nextVal = this.form.controls['brix_' + (i + 1)].value;
        this.form.controls['brix_' + i].setValue(nextVal);
        this.ficha['brix_' + i] = nextVal;
      }
      let lastIdx = this.brixCount - 1;
      this.form.removeControl('brix_' + lastIdx);
      delete this.ficha['brix_' + lastIdx];
      
      this.brixCount--;
      this.atualizarBrixTriplets();
      this.calcularMinMaxMediaBrix();
    }
  }

  calcularMinMaxMediaBrix() {
    let validValues = [];
    for (let i = 0; i < this.brixCount; i++) {
      let control = this.form.controls['brix_' + i];
      if (control) {
        let val = control.value;
        if (val !== null && val !== undefined && val !== '') {
          let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
          if (!isNaN(valFloat) && isFinite(valFloat)) {
            validValues.push(valFloat);
          }
        }
      }
    }

    if (validValues.length > 0) {
      this.brixMin = Math.min(...validValues);
      this.brixMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.brixMedia = sum / validValues.length;
    } else {
      this.brixMin = null;
      this.brixMax = null;
      this.brixMedia = null;
    }
  }

  formatTemp(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(2).replace('.', ',');
  }

  atualizarPressaoTriplets() {
    let triplets = [];
    for (let i = 0; i < this.pressaoCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.pressaoCount) trip.push(i + 1);
      if (i + 2 < this.pressaoCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.pressaoTriplets = triplets;
  }

  addPressao() {
    if (this.pressaoCount < 20) {
      let nextIdx = this.pressaoCount;
      let control = new FormControl('', []);
      this.form.setControl('pressao_' + nextIdx, control);
      this.ficha['pressao_' + nextIdx] = '';
      this.pressaoCount++;
      this.atualizarPressaoTriplets();
      this.calcularMinMaxMediaPressao();
      
      setTimeout(() => {
        let el = document.getElementById('pressao_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removePressao(idx: number) {
    if (this.pressaoCount > 1) {
      for (let i = idx; i < this.pressaoCount - 1; i++) {
        let nextVal = this.form.controls['pressao_' + (i + 1)].value;
        this.form.controls['pressao_' + i].setValue(nextVal);
        this.ficha['pressao_' + i] = nextVal;
      }
      let lastIdx = this.pressaoCount - 1;
      this.form.removeControl('pressao_' + lastIdx);
      delete this.ficha['pressao_' + lastIdx];
      
      this.pressaoCount--;
      this.atualizarPressaoTriplets();
      this.calcularMinMaxMediaPressao();
    }
  }

  calcularMinMaxMediaPressao() {
    let validValues = [];
    for (let i = 0; i < this.pressaoCount; i++) {
      let control = this.form.controls['pressao_' + i];
      if (control) {
        let val = control.value;
        if (val !== null && val !== undefined && val !== '') {
          let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
          if (!isNaN(valFloat) && isFinite(valFloat)) {
            validValues.push(valFloat);
          }
        }
      }
    }

    if (validValues.length > 0) {
      this.pressaoMin = Math.min(...validValues);
      this.pressaoMax = Math.max(...validValues);
      let sum = validValues.reduce((a, b) => a + b, 0);
      this.pressaoMedia = sum / validValues.length;
    } else {
      this.pressaoMin = null;
      this.pressaoMax = null;
      this.pressaoMedia = null;
    }
  }

  atualizarTamanhoCalibreTriplets() {
    let triplets = [];
    for (let i = 0; i < this.tamanhoCalibreCount; i += 3) {
      let trip = [i];
      if (i + 1 < this.tamanhoCalibreCount) trip.push(i + 1);
      if (i + 2 < this.tamanhoCalibreCount) trip.push(i + 2);
      triplets.push(trip);
    }
    this.tamanhoCalibreTriplets = triplets;
  }

  addTamanhoCalibre() {
    if (this.tamanhoCalibreCount < 20) {
      let nextIdx = this.tamanhoCalibreCount;
      let control = new FormControl('', []);
      this.form.setControl('tamanho_calibre_' + nextIdx, control);
      this.ficha['tamanho_calibre_' + nextIdx] = '';
      this.tamanhoCalibreCount++;
      this.atualizarTamanhoCalibreTriplets();
      
      setTimeout(() => {
        let el = document.getElementById('tamanho_calibre_' + nextIdx);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removeTamanhoCalibre(idx: number) {
    if (this.tamanhoCalibreCount > 1) {
      for (let i = idx; i < this.tamanhoCalibreCount - 1; i++) {
        let nextVal = this.form.controls['tamanho_calibre_' + (i + 1)].value;
        this.form.controls['tamanho_calibre_' + i].setValue(nextVal);
        this.ficha['tamanho_calibre_' + i] = nextVal;
      }
      let lastIdx = this.tamanhoCalibreCount - 1;
      this.form.removeControl('tamanho_calibre_' + lastIdx);
      delete this.ficha['tamanho_calibre_' + lastIdx];
      
      this.tamanhoCalibreCount--;
      this.atualizarTamanhoCalibreTriplets();
    }
  }

  getPesagemPesoMedio(pIdx: number): number {
    const vols = this.pesagens[pIdx] ? this.pesagens[pIdx].volumes : [];
    let validValues = [];
    vols.forEach((val, i) => {
      if (val !== null && val !== undefined && val !== '') {
        let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
        if (!isNaN(valFloat) && isFinite(valFloat)) {
          validValues.push(valFloat);
        }
      }
    });
    if (validValues.length > 0) {
      let sum = validValues.reduce((a, b) => a + b, 0);
      return sum / validValues.length;
    }
    return null;
  }

  getPesagemVolumeTriplets(pIdx: number): any[] {
    const vols = this.pesagens[pIdx] ? this.pesagens[pIdx].volumes : [];
    let triplets = [];
    for (let i = 0; i < vols.length; i += 3) {
      let trip = [i];
      if (i + 1 < vols.length) trip.push(i + 1);
      if (i + 2 < vols.length) trip.push(i + 2);
      triplets.push(trip);
    }
    return triplets;
  }

  atualizarPesagemTriplets(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (!pesagem) return;
    const vols = pesagem.volumes || [];
    let triplets = [];
    for (let i = 0; i < vols.length; i += 3) {
      let trip = [i];
      if (i + 1 < vols.length) trip.push(i + 1);
      if (i + 2 < vols.length) trip.push(i + 2);
      triplets.push(trip);
    }
    pesagem.triplets = triplets;
  }

  pesoLiquidoValidador = (control: FormControl) => {
    const isAddPrevista = this.pageIsAdd && (this.route.snapshot.queryParams['prevista'] == '1' || this.route.snapshot.queryParams['prevista'] == 1 || this.route.snapshot.queryParams['prevista'] == 'true');
    if (isAddPrevista) {
      return null;
    }

    const value = control.value;
    if (value === null || value === undefined) {
      return { required: true };
    }
    let strVal = String(value).trim();
    if (strVal === '') {
      return { required: true };
    }
    let floatVal = parseFloat(strVal.replace(',', '.'));
    if (isNaN(floatVal) || floatVal === 0) {
      return { required: true };
    }
    return null;
  };

  registrarControlesPesagem(pIdx: number, pesagemObj: any) {
    const isExibir = pesagemObj.exibir !== false && (pesagemObj.exibir as any) !== 'false' && (pesagemObj.exibir as any) !== 0 && (pesagemObj.exibir as any) !== '0';
    const exibirControl = new FormControl(isExibir, []);
    this.form.setControl(`pesagem_${pIdx}_exibir`, exibirControl);

    const taraControl = new FormControl(pesagemObj.tara || '', []);
    this.form.setControl(`pesagem_${pIdx}_tara`, taraControl);
    
    const pesoLiquidoControl = new FormControl(pesagemObj.peso_liquido || '', [this.pesoLiquidoValidador]);
    this.form.setControl(`pesagem_${pIdx}_peso_liquido`, pesoLiquidoControl);
    
    const diffControl = new FormControl(pesagemObj.diferenca_final || '', []);
    this.form.setControl(`pesagem_${pIdx}_diferenca_final`, diffControl);

    const vols = pesagemObj.volumes || [''];
    vols.forEach((vol, vIdx) => {
      const volControl = new FormControl(vol || '', []);
      this.form.setControl(`pesagem_${pIdx}_volume_${vIdx}`, volControl);
    });
  }

  removerControlesPesagem(pIdx: number, volumesCount: number) {
    this.form.removeControl(`pesagem_${pIdx}_exibir`);
    this.form.removeControl(`pesagem_${pIdx}_tara`);
    this.form.removeControl(`pesagem_${pIdx}_peso_liquido`);
    this.form.removeControl(`pesagem_${pIdx}_diferenca_final`);
    for (let vIdx = 0; vIdx < volumesCount; vIdx++) {
      this.form.removeControl(`pesagem_${pIdx}_volume_${vIdx}`);
    }
  }

  syncPesagensFromForm() {
    this.pesagens.forEach((pesagem, pIdx) => {
      const exibirControlName = `pesagem_${pIdx}_exibir`;
      if (this.form.controls[exibirControlName]) {
        pesagem.exibir = this.form.controls[exibirControlName].value;
      }
      const taraControlName = `pesagem_${pIdx}_tara`;
      if (this.form.controls[taraControlName]) {
        pesagem.tara = this.form.controls[taraControlName].value;
      }
      const pesoLiquidoControlName = `pesagem_${pIdx}_peso_liquido`;
      if (this.form.controls[pesoLiquidoControlName]) {
        pesagem.peso_liquido = this.form.controls[pesoLiquidoControlName].value;
      }
      const diffControlName = `pesagem_${pIdx}_diferenca_final`;
      if (this.form.controls[diffControlName]) {
        pesagem.diferenca_final = this.form.controls[diffControlName].value;
      }
      pesagem.volumes.forEach((vol, vIdx) => {
        const volControlName = `pesagem_${pIdx}_volume_${vIdx}`;
        if (this.form.controls[volControlName]) {
          pesagem.volumes[vIdx] = this.form.controls[volControlName].value;
        }
      });
    });
  }

  rebuildPesagemControls() {
    Object.keys(this.form.controls).forEach(key => {
      if (key.startsWith('pesagem_') || key === 'peso_liquido' || key === 'exibir_pesagem') {
        this.form.removeControl(key);
      }
    });

    this.pesagens.forEach((pesagem, pIdx) => {
      this.registrarControlesPesagem(pIdx, pesagem);
    });
  }

  addPesagem() {
    const pIdx = this.pesagens.length;
    const newPesagem = {
      volumes: ['', '', '', '', '', '', '', ''],
      tara: '',
      peso_liquido: '',
      diferenca_final: '',
      exibir: false
    };
    this.pesagens.push(newPesagem);
    this.registrarControlesPesagem(pIdx, newPesagem);
    this.atualizarPesagemTriplets(pIdx);
    this.atualizarPesoLiquidoVol();
  }

  removePesagem(pIdx: number) {
    if (this.pesagens.length > 1) {
      this.syncPesagensFromForm();
      
      this.pesagens.forEach((pesagem, idx) => {
        this.removerControlesPesagem(idx, pesagem.volumes.length);
      });

      this.pesagens.splice(pIdx, 1);

      this.rebuildPesagemControls();

      this.pesagens.forEach((_, idx) => {
        this.atualizarPesagemTriplets(idx);
      });
      this.atualizarPesoLiquidoVol();
    }
  }

  addPesagemVolume(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (pesagem && pesagem.volumes.length < 8) {
      const nextIdx = pesagem.volumes.length;
      pesagem.volumes.push('');
      
      const controlName = `pesagem_${pIdx}_volume_${nextIdx}`;
      let control = new FormControl('', []);
      this.form.setControl(controlName, control);
      
      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
      
      setTimeout(() => {
        let el = document.getElementById(controlName);
        if (el) {
          el.focus();
        }
      }, 50);
    }
  }

  removePesagemVolume(pIdx: number, idx: number) {
    const pesagem = this.pesagens[pIdx];
    if (pesagem && pesagem.volumes.length > 1) {
      const lastIdx = pesagem.volumes.length - 1;
      this.form.removeControl(`pesagem_${pIdx}_volume_${lastIdx}`);

      pesagem.volumes.splice(idx, 1);

      pesagem.volumes.forEach((val, i) => {
        const controlName = `pesagem_${pIdx}_volume_${i}`;
        if (this.form.controls[controlName]) {
          this.form.controls[controlName].setValue(val);
        }
      });

      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
    }
  }

  calcularPesoMedio(pIdx: number) {
    this.calcularDiferencaFinal(pIdx);
  }

  calcularDiferencaFinal(pIdx: number) {
    const pesagem = this.pesagens[pIdx];
    if (!pesagem) return;

    let pesoMedio = this.getPesagemPesoMedio(pIdx);
    
    let taraVal = this.form.controls[`pesagem_${pIdx}_tara`] ? this.form.controls[`pesagem_${pIdx}_tara`].value : null;
    let tara = 0;
    if (taraVal !== null && taraVal !== undefined && taraVal !== '') {
      tara = typeof taraVal === 'string' ? parseFloat(taraVal.replace(',', '.')) : parseFloat(taraVal);
      if (isNaN(tara) || !isFinite(tara)) tara = 0;
    }
    
    let pesoLiquidoVal = this.form.controls[`pesagem_${pIdx}_peso_liquido`] ? this.form.controls[`pesagem_${pIdx}_peso_liquido`].value : null;
    let pesoLiquido = 0;
    if (pesoLiquidoVal !== null && pesoLiquidoVal !== undefined && pesoLiquidoVal !== '') {
      pesoLiquido = typeof pesoLiquidoVal === 'string' ? parseFloat(pesoLiquidoVal.replace(',', '.')) : parseFloat(pesoLiquidoVal);
      if (isNaN(pesoLiquido) || !isFinite(pesoLiquido)) pesoLiquido = 0;
    }
    
    if (pesoMedio !== null && pesoMedio !== undefined) {
      let diff = pesoMedio - tara - pesoLiquido;
      pesagem.diferenca_final = diff.toFixed(3);
      if (this.form.controls[`pesagem_${pIdx}_diferenca_final`]) {
        this.form.controls[`pesagem_${pIdx}_diferenca_final`].setValue(pesagem.diferenca_final);
      }
    } else {
      pesagem.diferenca_final = '';
      if (this.form.controls[`pesagem_${pIdx}_diferenca_final`]) {
        this.form.controls[`pesagem_${pIdx}_diferenca_final`].setValue('');
      }
    }
    this.atualizarPesoLiquidoVol();
  }

  onSemPesagemChange(val: boolean) {
    if (val) {
      this.ficha.peso_liquido_vol = true;
      if (this.form.controls['peso_liquido_vol']) {
        this.form.controls['peso_liquido_vol'].setValue(true);
      }
    } else {
      this.atualizarPesoLiquidoVol();
    }
  }

  atualizarPesoLiquidoVol() {
    if (this.ficha.sem_pesagem) {
      this.ficha.peso_liquido_vol = true;
      if (this.form.controls['peso_liquido_vol']) {
        this.form.controls['peso_liquido_vol'].setValue(true);
      }
      return;
    }
    let isConforme = true;
    this.pesagens.forEach((pesagem) => {
      const exibir = pesagem.exibir !== false && (pesagem.exibir as any) !== 'false' && (pesagem.exibir as any) !== 0 && (pesagem.exibir as any) !== '0';
      if (exibir) {
        let diffVal = pesagem.diferenca_final;
        let diff = 0;
        if (diffVal !== null && diffVal !== undefined && diffVal !== '') {
          diff = typeof diffVal === 'string' ? parseFloat(diffVal.replace(',', '.')) : parseFloat(diffVal);
        }
        if (diffVal !== null && diffVal !== undefined && diffVal !== '' && !isNaN(diff) && diff < 0) {
          isConforme = false;
        }
      }
    });

    this.ficha.peso_liquido_vol = isConforme;
    if (this.form.controls['peso_liquido_vol']) {
      this.form.controls['peso_liquido_vol'].setValue(isConforme);
    }
  }

  formatPeso(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(3).replace('.', ',');
  }

  carregarPesagem() {
    this.pesagens = [];
    
    if (this.ficha.pesagem) {
      let parsed = typeof this.ficha.pesagem === 'string' ? JSON.parse(this.ficha.pesagem) : this.ficha.pesagem;
      if (Array.isArray(parsed)) {
        this.pesagens = parsed.map(p => {
          if (!p.hasOwnProperty('exibir')) {
            p.exibir = true;
          } else {
            p.exibir = p.exibir !== false && (p.exibir as any) !== 'false' && (p.exibir as any) !== 0 && (p.exibir as any) !== '0';
          }
          if (!p.volumes) {
            p.volumes = [];
          }
          while (p.volumes.length < 8) {
            p.volumes.push('');
          }
          if (p.volumes.length > 8) {
            p.volumes = p.volumes.slice(0, 8);
          }
          return p;
        });
      } else if (parsed && typeof parsed === 'object') {
        let vols = parsed.volumes || [];
        while (vols.length < 8) {
          vols.push('');
        }
        if (vols.length > 8) {
          vols = vols.slice(0, 8);
        }
        this.pesagens = [{
          volumes: vols,
          tara: parsed.tara || '',
          peso_liquido: this.ficha['peso_liquido'] || '',
          diferenca_final: parsed.diferenca_final || '',
          exibir: true
        }];
      }
    }
    
    if (this.pesagens.length === 0) {
      this.pesagens.push({
        volumes: ['', '', '', '', '', '', '', ''],
        tara: '',
        peso_liquido: '',
        diferenca_final: '',
        exibir: false
      });
    }

    this.rebuildPesagemControls();
    
    this.pesagens.forEach((_, pIdx) => {
      this.atualizarPesagemTriplets(pIdx);
      this.calcularPesoMedio(pIdx);
    });
  }

  addResponsavelTecnico() {
    let totalDisponivel = this.listResponsaveisTecnicos ? this.listResponsaveisTecnicos.length : 0;
    if (this.responsaveisTecnicosSelecionados.length >= totalDisponivel) {
      this.func.alerta(this.func.traduzir('front.erro'), this.func.traduzir('front.todosResponsaveisTecnicosJaAdicionados'), 'erro');
      return;
    }
    this.responsaveisTecnicosSelecionados.push(null);
  }

  removeResponsavelTecnico(i) {
    this.responsaveisTecnicosSelecionados.splice(i, 1);
  }

  getResponsaveisTecnicosDisponiveis(indexAtual: number) {
    if (!this.listResponsaveisTecnicos) return [];
    return this.listResponsaveisTecnicos.filter(rt => {
      let findIdx = this.responsaveisTecnicosSelecionados.findIndex(id => id != null && String(id) === String(rt.id));
      return findIdx === -1 || findIdx === indexAtual;
    });
  }

  getRtCargo(rt: any) {
    const lang = this.translateService.currentLang || 'pt';
    return rt['cargo_' + lang] || rt.cargo_pt || rt.cargo;
  }
}



// WEBPACK FOOTER //
// ./src/app/fichas/fichas-form.component.ts